import CampaignList from './CampaignList'
import CampaignCreate from './CampaignCreate'
import CampaignEdit from './CampaignEdit'
import CampaignShow from './CampaignShow'
import CampaignIcon from '@mui/icons-material/Campaign'

const campaigns = {
  list: CampaignList,
  create: CampaignCreate,
  show: CampaignShow,
  edit: CampaignEdit,
  icon: CampaignIcon,
}

export default campaigns
